import { useParams } from "react-router-dom";
import VendorList from "./VendorList";
import VendorDetail from "./VendorDetail";

/**
 * VENDORS
 * =======
 * The supplier side of the marketplace. Two routes, one entry point:
 *
 *   /dashboard/vendors        → the directory
 *   /dashboard/vendors/:id    → one vendor's record
 *
 * A vendor is a real address, not a modal, so a record can be linked to from
 * a review, a ticket or a chat message.
 *
 * The screen is split across four files because the list and the record share
 * almost nothing except the API and the vocabulary:
 *
 *   vendorApi.js    — wire format, shaping, formatting, sort comparators
 *   VendorBits.js   — badge, sortable header, empty/loading/error pieces
 *   VendorList.js   — the directory
 *   VendorDetail.js — one vendor
 *
 * Presentation leans on src/styles/opsConsole.module.css, which is shared
 * with Product approvals so the two screens read as the same product. That
 * file is co-owned and is never edited from here; anything this screen needs
 * on top of it lives in Vendors.module.css.
 *
 * Remounting on :id change (via `key`) is deliberate — without it, moving
 * between two vendors would leave the previous vendor's table sort and
 * decision draft sitting on the new record.
 */
export default function Vendors() {
  const { vendorId } = useParams();
  return vendorId ? <VendorDetail key={vendorId} id={vendorId} /> : <VendorList />;
}
